export const isStudentApp = process.env.REACT_APP_APP_NAME === 'mat-man-student';
